/**
 * Optional trace for legacy GET …/dropdown/params usage (non-SPA consumers / migrations).
 * Enable with `SDK_LOG_DROPDOWN_PARAMS=1` in Node, or `globalThis.__SGRC_LOG_DROPDOWN_PARAMS = true` in browser.
 *
 * @param {string} serviceName — e.g. class name or module id for support tickets
 */
export function logDropdownParamsInvocation(serviceName) {
    const enabled =
        (typeof process !== 'undefined' && process.env?.SDK_LOG_DROPDOWN_PARAMS === '1') ||
        (typeof globalThis !== 'undefined' && globalThis.__SGRC_LOG_DROPDOWN_PARAMS === true);
    if (!enabled) return;
    const msg = `[SDK] dropdown/params invoked (${serviceName}) — SPA should prefer referenceData`;
    if (typeof console !== 'undefined' && console.debug) {
        console.debug(msg);
    }
}
